import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';

import { MasterTab } from '../MasterTab';
import { deleteDataWithParameters, getAllDetails, getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { APP_STATES, COLLEGES, HOSPITAL, UPDATE_HOSPITAL } from '../../../config/ApiConstant';
import { SkeletonbodyTemplate, Skeletonitems, defaultPageRowOptions, defaultRowOptions, paginatorLinks, showingEntries } from '../../../appconfig/Settings';
import { HospitalMasterColumnsList } from '../../../appconfig/DatatableSetting';
import { Dialog } from 'primereact/dialog';
import { AddHospitalMasterValidate } from '../../../config/Validate';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { useNavigate } from 'react-router-dom';

export const HospitalMaster = () => {
    document.title = 'Hospital Master | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [addHospitalMaster, setAddHospitalMaster] = useState<any>({});
    const [hospitalList, sethospitalList] = useState<any>([]);

    const [addUpdateLoader, setAddUpdateLoader] = useState<boolean>(false);
    const [addUpdateModal, setAddUpdateModal] = useState<boolean>(false);
    const [editId, setEditId] = useState<any>(null);
    const [errors, setErrors] = useState<any>({});
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);

    //state
    const [statesList, setStatesList] = useState<any>([]);

    // useEffect
    useEffect(() => {
        getStates();
        getHospitalMasterList();
    }, []);

    // Get States
    const getStates = async () => {
        try {
            const response = await getAllDetailsDirect(APP_STATES);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setStatesList([]);
                } else {
                    let stateData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const stateObj: any = {};
                        stateObj['name'] = DataList[i].name;
                        stateObj['code'] = DataList[i].id;
                        stateData.push(stateObj);
                    }
                    setStatesList(stateData);
                }
            } else {
                setStatesList([]);
            }
        } catch (error: any) {
            setStatesList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'StateNm') {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        setAddHospitalMaster({ ...addHospitalMaster, [name]: val });
    };

    const rightToolbarTemplate = () => {
        return (
            <>
                <Button label="Hospital List" icon="pi pi-plus" className="p-button p-button-outlined mr-3" onClick={() => navigate('/app/hospital-list')} />
                <Button label="Add Hospital Master" icon="pi pi-plus" className="p-button" onClick={() => openAddModal()} />
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined ml-3"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Get hospitalList list
    const getHospitalMasterList = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetailsDirect(HOSPITAL);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    sethospitalList([]);
                } else {
                    sethospitalList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(true);
                sethospitalList([]);
            }
        } catch (error: any) {
            setPageLoad(true);
            sethospitalList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Open add modal
    const openAddModal = () => {
        setAddUpdateModal(true);
    };

    // Close add modal
    const closeAddUpdateModal = () => {
        setAddHospitalMaster({});
        setEditId(null);
        setAddUpdateLoader(false);
        setAddUpdateModal(false);
        setErrors({});
    };

    // Open edit modal
    const openEditModal = (rowData: any) => {
        let stateObj = {
            name: rowData?.StateName,
            code: rowData?.StateSrNo
        };

        setEditId(rowData?.HospNo);
        setAddHospitalMaster({
            hospitalName: rowData?.HospName,
            StateNm: stateObj,
            hospitalAddress: rowData?.Address
        });

        setAddUpdateModal(true);
    };

    // Open delete modal
    const openDeleteModal = (index: any) => {
        setDeleteId(index);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setDeleteModal(false);
    };

    // Template for action
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="flex">
                    <Button icon="pi pi-pencil" tooltip="Edit" tooltipOptions={{ position: 'top' }} className="p-button-rounded" onClick={() => openEditModal(rowData)} />
                    <Button icon="pi pi-trash" tooltip="Delete" tooltipOptions={{ position: 'top' }} className="p-button-danger p-button-rounded ml-2" onClick={() => openDeleteModal(rowData?.HospNo)} />
                </div>
            </>
        );
    };

    // On submit add update app
    const onSubmitAddUpdateApp = async () => {
        try {
            const { errors, isError } = AddHospitalMasterValidate(addHospitalMaster);
            setErrors(errors);
            //Check Error if no errors then call API
            if (!isError) {
                setAddUpdateLoader(true);
                //URL
                let apiUrl = HOSPITAL;
                //Request object
                const requestData: any = {
                    HospName: addHospitalMaster?.hospitalName,
                    Address: addHospitalMaster?.hospitalAddress,
                    StateName: addHospitalMaster?.StateNm?.name,
                    StateSrNo: addHospitalMaster?.StateNm?.code
                };

                if (!window.cn(editId)) {
                    requestData['HospNo'] = editId;
                    apiUrl = UPDATE_HOSPITAL;
                }
                //apicall
                const response = await postAllData(apiUrl, requestData);
                if (response && !window.cn(response)) {
                    setEditId(null);
                    setAddHospitalMaster({});
                    setAddUpdateLoader(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                    setTimeout(() => {
                        setAddUpdateModal(false);
                        getHospitalMasterList();
                    }, 1000);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setAddUpdateLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Delete application
    const deleteApplication = async () => {
        try {
            setDeleteLoader(true);
            // Delete api call
            const response = await deleteDataWithParameters(HOSPITAL + '?HospNo=' + deleteId);
            if (response) {
                setDeleteLoader(false);
                setDeleteModal(false);
                setDeleteId(null);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.data
                });
                setTimeout(() => {
                    getHospitalMasterList();
                }, 1500);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setDeleteLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDeleteLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <MasterTab mainTabLabel="Hospital Master" />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-3">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={hospitalList}
                                    showGridlines
                                    stripedRows
                                    className="datatable-responsive"
                                    emptyMessage="No Data Found"
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={hospitalList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    removableSort
                                >
                                    {HospitalMasterColumnsList.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {HospitalMasterColumnsList.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Add Update Dialog */}
            <Dialog
                visible={addUpdateModal}
                className="p-fluid"
                style={{ width: '550px' }}
                header={editId !== null ? 'Edit Hospital Data' : 'Add Hospital Data'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeAddUpdateModal} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => onSubmitAddUpdateApp()} loading={addUpdateLoader} />
                    </>
                }
                onHide={closeAddUpdateModal}
            >
                <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                        <label htmlFor="hospitalName">
                            Hospital Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputText
                                value={addHospitalMaster?.hospitalName}
                                name="hospitalName"
                                autoComplete="off"
                                placeholder="Enter College Name"
                                onChange={(e) => onInputChange(e, 'hospitalName')}
                                className={errors['hospitalName'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>

                        <small className="p-invalid-txt">{errors['hospitalName']}</small>
                    </div>

                    <div className="field col-12 md:col-12">
                        <label htmlFor="StateNm">
                            State <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={addHospitalMaster?.StateNm}
                                name="StateNm"
                                options={statesList}
                                filter
                                optionLabel="name"
                                placeholder="Select State"
                                onChange={(e) => onInputChange(e.value, 'StateNm')}
                                className={errors['StateNm'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['StateNm']}</small>
                    </div>

                    <div className="field col-12 md:col-12">
                        <label htmlFor="hospitalAddress">
                            Address <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputTextarea
                                rows={4}
                                value={addHospitalMaster?.hospitalAddress}
                                name="hospitalAddress"
                                autoComplete="off"
                                placeholder="Enter Address"
                                onChange={(e) => onInputChange(e, 'hospitalAddress')}
                                className={errors['hospitalAddress'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['hospitalAddress']}</small>
                    </div>
                </div>
            </Dialog>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete Hospital"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteApplication} loading={deleteLoader} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this Hospital, This will be deleted permentatly.</span>
                </div>
            </Dialog>
        </>
    );
};
